import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import "moment/locale/ko";

import { solarToLunar } from "../../../../../hooks/useLunar";
import { isOutsideCmpny, isWeather } from "../function/common";
import { ScheduleListContainer } from "../styled/scheduler";
import { calculateDday, isEventCategory, timeByDate } from "../function/common";
import HamburgerMenu from "./hamburgerMenu";

const ScheduleList = ({
  selected,
  isTablet,
  clickEvent,
  onDate,
  setIsBurgerOpen,
  isBurgerOpen,
  isHolidayOpen,
  todayWeather,
  openComponents,
  setOpenComponents,
}) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const isDarkMode = useSelector((state) => state?.scheduler?.isDarkMode);
  const company = useSelector((state) => state?.company?.data);

  const formatLunarDate = (date) => {
    const [year, month, day] = moment(date).format("YYYY-MM-DD").split("-");
    return solarToLunar(year, month, day);
  };

  return (
    <ScheduleListContainer
      className={`agenda ${isDarkMode}`}
      style={{
        transform: `translateY(${!isTablet ? "0" : openComponents.scheduleList ? "0" : "150%"})`,
      }}
      onClick={(e) =>
        e.target === e.currentTarget &&
        setOpenComponents((data) => ({ ...data, scheduleList: false }))
      }>
      <div className="inner">
        <div className="date">
          <span>{moment(onDate).format("MM월 DD일 dddd")}</span>
          <span>{formatLunarDate(onDate)}</span>
          {todayWeather && <div className="weather">{isWeather(todayWeather, true)}</div>}
        </div>
        <ul className="schedule">
          {selected
            ?.sort((a, b) => {
              const getOrder = (item) => {
                if (item.gbn === "H") return 0;
                if (item.gbn === "S") return 1;
                return item.dday === "Y" ? 2 : 3;
              };
              return getOrder(a) - getOrder(b);
            })

            .map((item, index) => (
              <li
                key={index}
                className={
                  item.gbn === "S" || item.gbn === "H"
                    ? "holiday"
                    : item.dday === "Y"
                    ? "d-day"
                    : `event ${isOutsideCmpny(item, company) ? "outside" : ""}`
                }
                style={item.color ? { borderColor: `#${item.color}` } : {}}
                onClick={() =>
                  ["S", "H"].includes(item.gbn) ? isHolidayOpen(item) : clickEvent(item)
                }>
                <div className="title">
                  {item.icon && (
                    <img
                      src={`/img/scheduler/${
                        item.gbn === "S" || item.gbn === "H"
                          ? item.icon
                          : `scheduler_icon_${item.icon}`
                      }`}
                    />
                  )}
                  <p className={item.completeYn === "Y" ? "complete" : ""}>{item.title}</p>
                </div>
                <div className="info">
                  {item.gbn === "S" || item.gbn === "H" ? null : item.dday === "Y" ? (
                    calculateDday(item.startDt)
                  ) : (
                    <>
                      <p>{timeByDate(onDate, item.startDt, item.endDt)}</p>
                      <p>
                        <span>{`${isEventCategory(item.gbn)}일정`}</span>
                        {item.gbn !== "P" ? (
                          <span>: {item.orgNm}</span>
                        ) : item.workerList && item.workerList[user.mberNo] ? (
                          <span> 공유</span>
                        ) : null}
                      </p>
                    </>
                  )}
                </div>
              </li>
            ))}
        </ul>
      </div>
      {isTablet && (
        <HamburgerMenu
          onDate={moment(onDate).format("YYYY-MM-DD HH:00:00")}
          isBurgerOpen={isBurgerOpen}
          setIsBurgerOpen={setIsBurgerOpen}
        />
      )}
    </ScheduleListContainer>
  );
};

export default ScheduleList;
